import { AnimatePresence, MotiView } from "moti";

import { BlockIcon } from "@whoosh/design-system/src/components/icons_v2/general";
import { WhooshThemeColors } from "@whoosh/design-system/src/theme/restyle/theme";
import { CustomColor, getSurfaceColor } from "@whoosh/utilities/src/colors";

import { useRestrictionBlockData } from "../../../../../Common/hooks/useRestrictionBlockData";
import { RestrictionMemberVisibility } from "../../hooks/__generated__/useTimeListComponentsAgendaFragment_agenda.graphql";
import { TimeListInfoCard } from "../TimeListInfoCard";
import { RestrictionBlockFooter } from "./RestrictionBlockFooter";

export type RestrictionBlockProps = {
  id: string;
  name: string;
  displayName: string | null;
  startAt: string | null;
  liftAt?: string | null;
  endAt: string | null;
  courseMessage: string;
  memberMessage?: string | null;
  allDay: boolean;
  visibility?: RestrictionMemberVisibility | null;
  visibilityColor?: CustomColor | null;
};

export const RestrictionBlock = ({
  name,
  displayName,
  liftAt,
  startAt,
  visibility,
  visibilityColor,
  courseMessage,
  memberMessage,
  endAt,
  allDay,
}: RestrictionBlockProps) => {
  const restrictionColorPrimitive: WhooshThemeColors = !!visibilityColor
    ? getSurfaceColor(visibilityColor)
    : "grayscale-800";

  const { subtitle, showRotatingBorder, hideCard } = useRestrictionBlockData({
    startAt,
    endAt,
    liftAt,
    allDay,
  });

  return visibility === "RESTRICTION_ONLY" ||
    visibility === "SLOTS_AND_RESTRICTION" ? (
    <AnimatePresence>
      {!hideCard ? (
        <MotiView
          from={{ opacity: 1, maxHeight: 2000 }}
          animate={{ opacity: 1, maxHeight: 2000 }}
          exit={{ opacity: 0, maxHeight: 0 }}
          exitTransition={{
            opacity: {
              type: "timing",
              duration: 1000,
            },
            maxHeight: {
              type: "timing",
              duration: 1000,
            },
          }}
        >
          <TimeListInfoCard
            title={displayName || name || ""}
            subTitle={subtitle}
            backgroundColor={restrictionColorPrimitive}
            bodyContent={memberMessage ?? courseMessage ?? ""}
            icon={<BlockIcon />}
            footer={<RestrictionBlockFooter unlocksAt={liftAt} />}
            courseMessage={courseMessage}
            showRotatingBorder={showRotatingBorder}
          />
        </MotiView>
      ) : null}
    </AnimatePresence>
  ) : null;
};
